var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "pa-0 ma-0",
      staticStyle: { "min-height": "calc(100vh - 125px)" },
      attrs: { fluid: "" },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "120" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "w-100 d-flex flex-column",
          staticStyle: { "min-height": "calc(100vh - 125px)" },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "py-0" },
            [
              _c(
                "v-row",
                {
                  staticStyle: { "max-width": "100%" },
                  attrs: { "no-gutters": "" },
                },
                [
                  _c("v-icon", { staticClass: "m-2 pt-2" }, [
                    _vm._v("mdi-calendar-clock"),
                  ]),
                  _c("h3", { staticClass: "ml-2 mt-2" }, [
                    _vm._v(_vm._s(_vm.$t("timeReport"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticStyle: { "min-width": "0" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-8", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.reportTypes,
                                  label: _vm.$t("reportType"),
                                  color: "primary",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.selectedReportType,
                                  callback: function ($$v) {
                                    _vm.selectedReportType = $$v
                                  },
                                  expression: "selectedReportType",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  disabled: _vm.selectAllEmployees,
                                  items: _vm.teams,
                                  label: _vm.$t("teams"),
                                  color: "primary",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.selectedTeam,
                                  callback: function ($$v) {
                                    _vm.selectedTeam = $$v
                                  },
                                  expression: "selectedTeam",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.employees,
                                  disabled: _vm.selectAllEmployees,
                                  "item-text": "name",
                                  label: _vm.$t("employees"),
                                  multiple: "",
                                  "return-object": "",
                                  chips: "",
                                  "small-chips": "",
                                  color: "primary",
                                  dense: "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function (data) {
                                      return [
                                        data.index < 5
                                          ? _c(
                                              "v-chip",
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    "input-value":
                                                      data.selected,
                                                    close: "",
                                                  },
                                                  on: {
                                                    click: data.select,
                                                    "click:close": function (
                                                      $event
                                                    ) {
                                                      return _vm.removeSelectedEmployee(
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-chip",
                                                data.attrs,
                                                false
                                              ),
                                              [_vm._v(_vm._s(data.item.name))]
                                            )
                                          : _vm._e(),
                                        data.index === 5
                                          ? _c("span", [_vm._v(" ... ")])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item",
                                    fn: function (data) {
                                      return [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(data.item.name)),
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.setTeamsForAutocomplete(
                                                    data.item.teams
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.selectedEmployees,
                                  callback: function ($$v) {
                                    _vm.selectedEmployees = $$v
                                  },
                                  expression: "selectedEmployees",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "3" } },
                            [
                              _c("v-checkbox", {
                                staticClass: "mt-2 pt-0",
                                attrs: {
                                  label: _vm.$t("selectAllEmployees"),
                                  dense: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.selectAllEmployees,
                                  callback: function ($$v) {
                                    _vm.selectAllEmployees = $$v
                                  },
                                  expression: "selectAllEmployees",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.selectedReportType == _vm.$t("monthly")
                ? _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { cols: "12", md: "4", lg: "3" },
                        },
                        [
                          _c("v-date-picker", {
                            attrs: {
                              type: "month",
                              "full-width": "",
                              "first-day-of-week": 1,
                              color: "green lighten-1",
                            },
                            model: {
                              value: _vm.date,
                              callback: function ($$v) {
                                _vm.date = $$v
                              },
                              expression: "date",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", lg: "3" } },
                        [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: _vm.$t("from"),
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.fromDate,
                                                callback: function ($$v) {
                                                  _vm.fromDate = $$v
                                                },
                                                expression: "fromDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("v-date-picker", {
                                attrs: {
                                  max: _vm.toDate || _vm.today,
                                  "show-current": "false",
                                  "first-day-of-week": 1,
                                  color: "primary",
                                },
                                model: {
                                  value: _vm.fromDate,
                                  callback: function ($$v) {
                                    _vm.fromDate = $$v
                                  },
                                  expression: "fromDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: _vm.$t("until"),
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.toDate,
                                                callback: function ($$v) {
                                                  _vm.toDate = $$v
                                                },
                                                expression: "toDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _c("v-date-picker", {
                                attrs: {
                                  min: _vm.fromDate,
                                  max: _vm.today,
                                  "show-current": "false",
                                  "first-day-of-week": 1,
                                  color: "green lighten-1",
                                },
                                model: {
                                  value: _vm.toDate,
                                  callback: function ($$v) {
                                    _vm.toDate = $$v
                                  },
                                  expression: "toDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "pt-0 mt-auto" },
            [
              _c(
                "v-row",
                { attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex justify-end",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "font-weight-medium mt-3",
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.ShowTimeReport = true
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("request")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.ShowTimeReport
        ? _c("MonthlyTimeReport", {
            attrs: {
              items: this.selectedEmployees,
              date: _vm.date,
              fromDate: _vm.fromDate,
              toDate: _vm.toDate,
              isTimespan: _vm.selectedReportType != _vm.$t("monthly"),
            },
            on: {
              close: function ($event) {
                _vm.ShowTimeReport = false
                _vm.monthlyHistories = []
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }